import React from 'react';
import {DataTypeProvider} from '@devexpress/dx-react-grid';
import DateFormatter from 'util/components/DateFormatter';

const DateProvider = (props) => <DataTypeProvider formatterComponent={DateFormatter} {...props} />;

export default DateProvider;
